import { render, staticRenderFns } from "./ListPriceRule.vue?vue&type=template&id=24dcf488&scoped=true"
import script from "./ListPriceRule.vue?vue&type=script&lang=js"
export * from "./ListPriceRule.vue?vue&type=script&lang=js"
import style0 from "./ListPriceRule.vue?vue&type=style&index=0&id=24dcf488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dcf488",
  null
  
)

export default component.exports